import React from 'react'
import { Tabs } from 'antd'

export const PreviewContactUs = ({ changeContactUsTab, contactUsKey, responseData, activeKey, loading, CompLoader,
    ContactUSComp, ContactUSSocialMedia, Reviews }

) => {
    return (
      <div>
   <Tabs
                  onChange={changeContactUsTab}
                  defaultActiveKey={contactUsKey}
                >

                  <Tabs.TabPane tab="Reviews" key="REVIEWS">
                    <div className="rowBody preview-tab-container">
                      <Reviews val={false} />
                    </div>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Sales" key="SALES">
                    <div className="rowBody preview-tab-container">
                      {loading ? (
                        <CompLoader />
                      ) : activeKey === "contact-us" &&
                        contactUsKey === "SALES" &&
                        responseData &&
                        responseData.length > 0 ? (
                        responseData.map((data) => {
                          return <ContactUSComp data={data} />;
                        })
                      ) : (
                        <div className="background-container">
                          <span>Nothing here at the moment</span>
                        </div>
                      )}
                    </div>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Human Resources" key="HUMAN_RESOURCE">
                    <div className="rowBody preview-tab-container">
                      {loading ? (
                        <CompLoader />
                      ) : activeKey === "contact-us" &&
                        contactUsKey === "HUMAN_RESOURCE" &&
                        responseData &&
                        responseData.length > 0 ? (
                        responseData.map((data) => {
                          return <ContactUSComp data={data} />;
                        })
                      ) : (
                        <div className="background-container">
                          <span>Nothing here at the moment</span>
                        </div>
                      )}
                    </div>
                  </Tabs.TabPane>
                  <Tabs.TabPane
                    tab="Experiences of work"
                    key="EXPERIENCES_OF_WORK"
                  >
                    <div className="rowBody preview-tab-container">
                      {loading ? (
                        <CompLoader />
                      ) : activeKey === "contact-us" &&
                        contactUsKey === "EXPERIENCES_OF_WORK" &&
                        responseData &&
                        responseData.length > 0 ? (
                        responseData.map((data) => {
                          return <ContactUSComp data={data} />;
                        })
                      ) : (
                        <div className="background-container">
                          <span>Nothing here at the moment</span>
                        </div>
                      )}
                    </div>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Social media" key="SOCIAL_MEDIA">
                    <div className="rowBody preview-tab-container">
                      {loading ? (
                        <CompLoader />
                      ) : activeKey === "contact-us" &&
                        contactUsKey === "SOCIAL_MEDIA" &&
                        responseData &&
                        responseData.length > 0 ? (
                        responseData.map((data) => {
                          return <ContactUSSocialMedia data={data} />;
                        })
                      ) : (
                        <div className="background-container">
                          <span>Nothing here at the moment</span>
                        </div>
                      )}
                    </div>
                  </Tabs.TabPane>
                </Tabs>

      </div>
       
    )
}

